// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"e54baa20","147":"a4f36a34","294":"a4f36a34","321":"a4f36a34","546":"a4f36a34"}[chunkId] + ".chunk.css";
};